<template>
  <div>
    <div class="p-brandForm">
      <div class="p-box">
        <div class="p-box__body">
          <Info>
            <p>{{ $t('pages.companies.management.brands.info1') }}</p>
            <p v-if="!isDocomoPlan">{{ $t('pages.companies.management.brands.info2') }}</p>
          </Info>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form v-if="!loading" @submit.prevent="handleSubmit($event, onSubmit)">
              <div class="field">
                <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                  <label class="c-formLabel">{{ $t('models.brand.logo') }}</label>
                  <div class="p-brandForm__brandLogoWrapper">
                    <img class="p-brandForm__brandLogo" :src="imageUrl" width="176">
                  </div>
                  <label class="c-fileLoader">
                    <div class="c-fileLoader__icon"><img :src="iconPlusPath" alt=""></div>
                    <div class="c-fileLoader__name">{{ $t('labels.selectImage') }}</div>
                    <input
                      ref="brand_cover_image"
                      type="file"
                      accept="image/jpeg,image/png"
                      @change="onFileChange"
                    >
                  </label>
                  <KkTooltip :label="$t('labels.imageTooltipContent.title')"
                             top="25px"
                             width="400px"
                             :is-visible="isShowHoverImageTooltip"
                             @show-tooltip="showHoverImageTooltip"
                             @hide-tooltip="hideHoverImageTooltip"
                  >
                    <KkImageTooltipContent count="1" format="JPEG,PNG" width="1,280" height="600" size="5" :is-visible-resize="false" :is-visible-simple-description="true" />
                  </KkTooltip>
                </fieldset>
                <template v-if="!isDocomoPlan">
                  <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                    <input
                      id="checkbox"
                      v-model="gmbStoreLogoSynced"
                      class="c-checkbox__input"
                      type="checkbox"
                    >
                    <label class="c-checkbox__label" for="checkbox">
                      {{ $t('pages.companies.brandForm.syncGmbStoreLogo') }}
                    </label>
                  </fieldset>
                  <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__6 p-formGrid__item__l__6">
                    <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="name" :name="$t('models.brand.name')" rules="required">
                      <label class="c-formLabel">{{ $t('models.brand.name') }}</label>
                      <TextField :value="value" class="c-textField" :placeholder="$t('labels.placeholder.enter', { value: $t('models.brand.name') })" @input="handleChange" />
                      <ValidationError :error="errors[0]" />
                    </ValidationProvider>
                  </fieldset>
                  <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__6 p-formGrid__item__l__6">
                    <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="businessTypeId" :name="$t('models.businessType.modelName')" rules="required">
                      <label class="c-formLabel">{{ $t('models.businessType.modelName') }}</label>
                      <Select :model-value="value" :options="businessTypes" @update:model-value="handleChange" />
                      <ValidationError :error="errors[0]" />
                    </ValidationProvider>
                  </fieldset>
                </template>
              </div>
              <div class="c-button c-button--right">
                <router-link class="c-button__item c-button__item--outline-cancel" :to="`/s/companies/${ currentCompanyUuid }/management`">{{ $t('labels.cancel') }}</router-link>
                <button class="c-button__item c-button__item--primary">
                  {{ $t('labels.save') }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
        <Loading v-show="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Info from '../components/Info'
import Loading from '../components/Loading'
import TextField from '../components/TextField'
import Select from '../components/Select'
import ValidationError from '../components/ValidationError'
import iconPlusPath from '../../../images/common/icon_plus.svg'
import ImgDefaultBrand from '../../../images/default.png'
import { KkTooltip, KkImageTooltipContent } from '../components/base'

export default {
  components: {
    Info,
    Loading,
    TextField,
    Select,
    ValidationError,
    KkTooltip,
    KkImageTooltipContent,
  },
  data() {
    return {
      iconPlusPath,
      name: '',
      businessTypeId: null,
      imageUrl: '',
      initGmbStoreLogoSynced: null,
      gmbStoreLogoSynced: false,
      file: null,
      isShowHoverImageTooltip: false,
    }
  },
  computed: {
    ...mapState({
      brand: state => state.companiesBrand.data,
      brand_loading: state => state.companiesBrand.loading,
      errors: state => state.companiesBrand.errors,
      business_types: state => state.companiesBusinessTypes.data.data,
      business_types_loading: state => state.companiesBusinessTypes.loading,
    }),
    ...mapGetters({
      isDocomoPlan: 'companiesCompany/isDocomoPlan',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentBrandId() {
      return this.$route.params.brand_id
    },
    imgDefaultBrand() {
      return ImgDefaultBrand
    },
    // 更新前trueで更新後falseかの判定
    isChangedGmbStoreLogoSyncedToFalse() {
      return this.initGmbStoreLogoSynced && !this.gmbStoreLogoSynced
    },
    businessTypes() {
      const obj = {}
      this.business_types.map(v => {
        const attributes = v.attributes
        obj[attributes.name] = v.id
      })
      return obj
    },
    loading: function() {
      return this.brand_loading || this.business_types_loading
    },
  },
  async created() {
    this.imageUrl = this.imgDefaultBrand
    this.readBusinessTypes()
    if (this.currentBrandId) {
      await this.readBrand({ company_uuid: this.currentCompanyUuid, brand_id: this.currentBrandId })
      this.name = this.brand.attributes.name
      this.imageUrl = this.brand.attributes.image_url
      this.businessTypeId = this.brand.attributes.business_type_id
      this.initGmbStoreLogoSynced = this.brand.attributes.gmb_store_logo_synced
      this.gmbStoreLogoSynced = this.brand.attributes.gmb_store_logo_synced
    }
  },
  methods: {
    ...mapActions({
      readBrand: 'companiesBrand/readBrand',
      createBrand: 'companiesBrand/createBrand',
      updateBrand: 'companiesBrand/updateBrand',
      readBrands: 'companiesBrands/readBrands',
      readBusinessTypes: 'companiesBusinessTypes/readBusinessTypes'
    }),
    async onSubmit() {
      if (this.isChangedGmbStoreLogoSyncedToFalse) {
        if (!confirm(this.$t('pages.companies.brandForm.changeGmbStoreLogoSyncedToFalse'))) return
      }
      const payload = {
        name: this.name,
        business_type_id: this.businessTypeId,
        gmb_store_logo_synced: this.gmbStoreLogoSynced,
      }
      if (this.file) {
        payload.image =  {
          content: await this.readAsDataURL(this.file),
          filename: this.file.name,
        }
      }
      await this.submitApi(payload)
      this.$router.push({ name: 'CompaniesManagementBrands', params: { company_uuid: this.currentCompanyUuid } })
    },
    readAsDataURL(blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => { resolve(reader.result) }
        reader.onerror = () => { reject(reader.error) }
        reader.readAsDataURL(blob)
      })
    },
    onFileChange(e) {
      const file = e.target.files[0]
      this.file = file
      this.imageUrl = window.URL.createObjectURL(this.file)
    },
    submitApi(payload) {
      if (this.currentBrandId) {
        return this.updateBrand({ company_uuid: this.currentCompanyUuid, brand_id: this.currentBrandId, payload: payload })
      } else {
        return this.createBrand({ company_uuid: this.currentCompanyUuid, payload: payload })
      }
    },
    showHoverImageTooltip() {
      this.isShowHoverImageTooltip = true
    },
    hideHoverImageTooltip() {
      this.isShowHoverImageTooltip = false
    },
  },
}
</script>
<style lang="scss" scoped>
.imageInfo {
  margin-top: 8px;
}
.tooltipBox {
  margin-top: 8px;
}
form[data-gtm-form-interact-id='0'] > .field > fieldset > .p-brandForm__brandLogoWrapper {
  background-color: #fff;
}
</style>
